import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { PageLoader } from '@customerio/pluma-components/react';

const NewsletterSentDeliveryPage = lazy(
  () => import('@/pages/workspaces/broadcasts/newsletter/overview/sent/delivery/index.page'),
);

function NewsletterSentDeliveryRoute() {
  const { newsletterId, deliveryId } = Route.useParams();
  return (
    <Suspense fallback={<PageLoader label="Loading…" />}>
      <NewsletterSentDeliveryPage key={deliveryId} newsletterId={newsletterId} deliveryId={deliveryId} />
    </Suspense>
  );
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/overview/sent/$deliveryId',
)({ component: NewsletterSentDeliveryRoute });
